<template>
  <v-container>
    <v-layout row v-if='myPatient==null' justify-center class='startbtn'>
      <v-btn color="primary" dark @click.native.stop='openselector'>Click here to select a Patient</v-btn>
    </v-layout>
    <v-layout row wrap justify-center align-space-around v-else>
      <v-flex xs12>
        <v-layout row wrap justify-center align-space-around  mb-4>

          <v-flex xs12 md3 pb-1 mx-1 elevation-3  class='patientpanel text-xs-center text-sm-center text-md-center text-lg-center'>
            <v-layout row wrap >
              <v-flex xs12 class='blue darken-3'px-1>
                <span class='display-1 white--text'>INPUT</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-for='entry in patientModel.patient.features' :key='entry.label'>
              <v-flex xs10 offset-xs1 py-1>
                <v-text-field
                  v-model="entry.value"
                  :label="entry.label"
                  :box="inEditMode"
                  v-if='entry.label=="Age"'
                >
                </v-text-field>
                <v-select
                  v-model="entry.value"
                  :items="raceitems"
                  :label="entry.label"
                  v-if='entry.label=="Race"'
                ></v-select>
                <v-select
                  v-model="entry.value"
                  :items="genderitems"
                  :label="entry.label"
                  v-if='entry.label=="Gender"'
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs10 offset-xs1 py-1>
                <v-expansion-panel popout open my-3 >
                  <v-expansion-panel-content
                    key="filter"
                  >
                    <div slot="header">Options</div>
                    <v-layout row wrap justify-center>
                      <v-flex xs10>
                      <v-radio-group v-model="patientModel.options.lifetableedition" :mandatory="false">
                        <v-radio label="Life Table for 2005" value="2005"></v-radio>
                        <v-radio label="Life Table for 2015"  value="2015"></v-radio>
                      </v-radio-group>
                </v-flex>
                </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs10 offset-xs1 py-1>
                <v-btn @click='calculate'>Calculate Life Expectancy</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md1 pb-1 mx-1 v-if='hideflow'>
            <v-layout row wrap>
            </v-layout>
            <v-layout row wrap align-end>
              <v-flex xs12 class='text-xs-center text-sm-center text-md-center text-lg-center'>
                <v-btn @click='showExecutiveflow'>
                  <v-icon>first_page</v-icon>
                  <v-icon>last_page</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md5 pb-1 mx-1 elevation-3 v-else>
            <v-layout row wrap align-center justify-center>
              <v-flex xs12 class='text-xs-center text-sm-center text-md-center text-lg-center'>
                <v-btn @click='hideExecutiveflow'>
                  <v-icon>last_page</v-icon>
                  <v-icon>first_page</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center justify-center>
              <v-flex xs12 class='text-lg-center'>
                <v-layout row wrap align-center justify-center my-3 py-2>
                  <v-flex xs1 class='text-xs-center text-sm-center text-md-center text-lg-center'>
                    <v-progress-linear height='10' :indeterminate="true" v-if="stepSelected=='1'"></v-progress-linear>
                    <v-icon x-large v-else>arrow_forward</v-icon>
                  </v-flex>
                    <v-flex xs10 elevation-2 class='ko'>
                      <v-layout row wrap >
                        <v-flex xs12 class='grey darken-3'px-1>
                          <span class='headline white--text'>IPP EXECUTIVE OBJECT</span>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap >
                        <v-flex xs12 px-1>
                          <span>KNOWLEDGE OBJECT </span> <span class='headline'> ark:/ipp/executive</span><br>
                          <span>IMPLEMENTATION </span> <span class='headline'> v0.0.2</span>
                        </v-flex>
                      </v-layout>

                    </v-flex>
                      <v-flex xs1 class='text-xs-center text-sm-center text-md-center text-lg-center'>
                        <v-progress-linear height='10' :indeterminate="true" v-if="stepSelected=='6'"></v-progress-linear>
                        <v-icon x-large v-else>arrow_forward</v-icon>
                      </v-flex>

                </v-layout>
                <v-layout row wrap align-space-around fill-height>
                  <v-flex xs2>
                  </v-flex>
                  <v-flex xs1>
                    <v-progress-linear height='10' class='rotdown' :indeterminate="true" v-if="stepSelected=='2'"></v-progress-linear>
                    <v-icon x-large v-else>arrow_downward</v-icon>

                  </v-flex>
                  <v-flex xs1>
                    <v-progress-linear height='10' class='rotup' :indeterminate="true" v-if="stepSelected=='3'"></v-progress-linear>
                    <v-icon x-large v-else>arrow_upward</v-icon>
                  </v-flex>
                  <v-flex xs4></v-flex>
                  <v-flex xs1>
                    <v-progress-linear height='10' class='rotdown' :indeterminate="true" v-if="stepSelected=='4'"></v-progress-linear>
                    <v-icon x-large v-else>arrow_downward</v-icon>

                  </v-flex>
                  <v-flex xs1>
                    <v-progress-linear height='10' class='rotup' :indeterminate="true" v-if="stepSelected=='5'"></v-progress-linear>
                    <v-icon x-large v-else>arrow_upward</v-icon>
                  </v-flex>
                  <v-flex xs2></v-flex>
                </v-layout>
                <v-layout row wrap my-3 py-2>
                  <v-flex xs1></v-flex>
                  <v-flex class='ko' elevation-2 xs4>
                    <v-layout row wrap >
                      <v-flex xs12 class='grey darken-3'px-1>
                        <span class='headline white--text'>LIFE TABLE OBJECT</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap >
                      <v-flex xs12 px-1>
                        <span>KNOWLEDGE OBJECT </span> <span class='title'> ark:/ipp/lifetable</span><br>
                        <span>IMPLEMENTATION </span> <span class='title'>2005</span><br>
                        <span>IMPLEMENTATION </span> <span class='title'>2015</span>
                      </v-flex>
                    </v-layout>

                  </v-flex>
                  <v-flex xs2></v-flex>
                  <v-flex class='ko' elevation-2 xs4>
                    <v-layout row wrap >
                      <v-flex xs12 class='grey darken-3'px-1>
                        <span class='headline white--text'>LIFE EXPECTANCY CALCULATOR</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap >
                      <v-flex xs12 px-1>
                        <span>KNOWLEDGE OBJECT </span> <span class='title'> ark:/ipp/lecalculator</span><br>
                        <span>IMPLEMENTATION </span> <span class='title'>v0.0.5</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1></v-flex>
                </v-layout>
                <v-layout row wrap>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md3 pb-1 mx-1 elevation-3 >
            <v-layout row wrap >
              <v-flex xs12 class='blue darken-3 text-xs-center text-sm-center text-md-center text-lg-center' px-1>
                <span class='display-1 white--text'>OUTCOME</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center justify-center fill-height>
              <v-flex xs12 px-4>
                  <v-card color="#efefef">
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12 px-1>
                        <span class="headline">Life Expectancy</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap style="min-height:180px;margin-top:40px;">
                      <v-flex xs12 sm12 md12 justify-center align-center class='text-xs-center text-sm-center text-md-center text-lg-center'>
                        <span class='display-4' v-if='showFinal'>{{lifeexpectancy | decimal2}}</span>
                      </v-flex>
                    </v-layout row wrap>
                    <v-layout>
                      <v-flex xs12 sm12 md12 class='text-xs-center text-sm-center text-md-center text-lg-center' px-1>
                        <span class='body-1' v-if='outcome.lifeexpectancy'>Data Source: </span>
                        <span class='subheading' v-if='outcome.lifeexpectancy'>{{source}}</span>
                      </v-flex>
                    </v-layout>
                  </v-card>
                  </v-flex>
          </v-layout>
          </v-flex>
        </v-layout>
        <v-divider v-if='!hideflow'></v-divider>
        <v-layout row wrap v-if='!hideflow'>
          <v-flex xs12>
          <v-stepper v-model='stepSelected' non-linear >
              <v-stepper-header>
                <v-stepper-step
                  editable
                  step="1"
                >
                  Receive and parse INPUT
                </v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step
                  editable
                  step="2"
                >
                  Call Life Table Object
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step
                  editable
                  step="3"
                >
                  Receive Mortality Rate Set
                </v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step
                  step="4"
                  editable
                >
                  Call Life Expectancy Calculator
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step
                  editable
                  step="5"
                >
                  Receive Life Expectancy
                </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step
                    editable
                    step="6"
                  >
                    Return Result
                  </v-stepper-step>
              </v-stepper-header>
            </v-stepper>
          </v-flex>
        </v-layout>
        <!-- <v-layout row wrap v-if='!hideflow'>
          <v-flex xs12>
          <v-stepper v-model='stepSelected' non-linear >
              <v-stepper-header>
                <span v-for='(value, key) in outcome.eventlog'>
                <v-stepper-step
                  editable
                  :step="value.stage"
                >
                {{value.name}}
                </v-stepper-step>
                <hr class='v-divider'>
              </span>
              </v-stepper-header>
            </v-stepper>
          </v-flex>
        </v-layout> -->
        <v-layout row wrap justify-center align-space-around mt-2 v-if='!hideflow'>
          <v-flex xs4 class='patientpanel' elevation-2 pa-2>
            <tree-view :data="displayPanel" :options="{maxDepth: 1, rootObjectKey: 'Patient'}" ></tree-view>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    name: 'Demo1',
    data: () => ({
      events: [],
      input: null,
      nonce: 0,
      executiveko:{"naan":'ipp',"name":'executive',"ver":'v0.0.2','endpoint':'process'},
      reclistready: false,
      lifegainendpoint:'lifeexpectancygained',
      eventlog: [],
      valid: true,
      patientFeaturePanel:{},
      patientready:true,
      reccomputed:0,
      checkbox: false,
      dialog: false,
      patientIndex: -1,
      windowHeight:0,
      outcome:{},
      patientModel:{},
      inEditMode:false,
      hideflow:true,
      stepSelected:"0",
      raceitems:['White','Black','Others'],
      genderitems:['Male','Female','Others']
    }),
    created: function(){
      this.$bus.$on('selectPatient', this.selectPatient )
    },
    mounted: function() {
      var self=this
      this.windowHeight = window.innerHeight
      window.addEventListener('resize', () => {
          self.windowHeight = window.innerHeight
        });
      this.patientIndex=this.$store.getters.getCurrentPatientIndex
      this.patientModel= JSON.parse(JSON.stringify(this.myDemoPatient))
      if(!this.patientModel.options.lifetableedition){
        this.patientModel.options.lifetableedition="2005"
      }
    },
    components:{
    },
    watch:{
      myPatient: function(){
        this.patientModel= JSON.parse(JSON.stringify(this.myDemoPatient))
        if(!this.patientModel.options.lifetableedition){
          this.patientModel.options.lifetableedition="2005"
        }
      }
    },
    computed: {
      showFinal:function(){
        var bool = false
        if(this.hideflow){
          bool = this.outcome.lifeexpectancy
        }else {
          bool= (this.stepSelected>='6')
        }
        return bool
      },
      displayPanel: function(){
        var obj={}
        obj.patient={}
        console.log(JSON.stringify(obj))
        if(this.outcome.id){
          obj.patient.id = this.outcome.id
          obj.patient.features = JSON.parse(JSON.stringify(this.outcome.features))
          // obj.options = JSON.parse(JSON.stringify(this.outcome.options))
          switch(this.stepSelected){
            case "1":
              break;
            case "2":
              break;
            case "3":
                obj.mortalityrate = JSON.parse(JSON.stringify(this.outcome.mortalityrate))
                break;
            case "4":
                obj.mortalityrate = JSON.parse(JSON.stringify(this.outcome.mortalityrate))
                break;
            case "5":
              obj.mortalityrate = JSON.parse(JSON.stringify(this.outcome.mortalityrate))
              // obj.survivalrate = JSON.parse(JSON.stringify(this.outcome.mortalityrate))
              // obj.conditionalsurvivalrate = JSON.parse(JSON.stringify(this.outcome.conditionalsurvivalrate))
              // obj.contributed = JSON.parse(JSON.stringify(this.outcome.contributed))
              obj.lifeexpectancy = JSON.parse(JSON.stringify(this.outcome.lifeexpectancy))
              break;
            default:
              obj.mortalityrate = JSON.parse(JSON.stringify(this.outcome.mortalityrate))
              // obj.survivalrate = JSON.parse(JSON.stringify(this.outcome.mortalityrate))
              // obj.conditionalsurvivalrate = JSON.parse(JSON.stringify(this.outcome.conditionalsurvivalrate))
              // obj.contributed = JSON.parse(JSON.stringify(this.outcome.contributed))
              obj.lifeexpectancy = JSON.parse(JSON.stringify(this.outcome.lifeexpectancy.baseline))
              break;
          }
        }
        return obj
      },
      source () {
          return "CDC Life Table"
      },
      // letype () {
      //   return this.outcome.settings.type
      // },
      // lename () {
      //   return this.outcome.settings.name
      // },
      lifeexpectancy: function(){
        return this.outcome.lifeexpectancy.baseline
      },
      panelheight: function(){
        return this.windowHeight - 180
      },
      panelStyle () {
        return {
          height: `${this.panelheight}px`,
        }
      },
      timeline () {
        return this.events.slice().reverse()
      },
      // activator_url:'http://localhost:8080/',
      activator_url: function(){
        // return this.$store.getters.getactivatorurls[0]
        return 'http://localhost:8082/'
      },
      library_url: function(){
        return 'http://localhost:8082/shelf'
        // return this.$store.getters.getlibraryurl
      },
      objlink:function(){
        return this.library_url+'/#/object/'+this.executiveko.naan+'%2F'+this.executiveko.name+'%2F'+this.executiveko.ver
      },

      myPatient: function(){
        if(this.patientIndex!=-1){
          return this.$store.getters.getPatientPanel(this.patientIndex)
        } else {
          return null
        }
      },
      myDemoPatient: function() {
        var pt = {}
        pt.patient={}
        pt.patient.id = this.myPatient.patient.id
        pt.patient.features=[]
        this.myPatient.patient.features.forEach(function(e){
          if(e.group=='demographics'){
            pt.patient.features.push(e)
          }
        })
        pt.options=this.myPatient.options
        return pt
      },
      myPatientDisplay: function(){
        var groupPanel = {}
        if(this.myPatient!=null){
          this.myPatient.patient.features.forEach(function(e){
            if(groupPanel[e.group]==null){
              groupPanel[e.group]=[]
            }
            groupPanel[e.group].push(e)
          })
        }
        return groupPanel
      },
      groupSchema:function(){
          return this.$store.getters.getGroupDisplaySchema
      }
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      decimal2: function(value) {
        if(!value) return ''
        return value.toFixed(2)
      }
    },
    methods: {
      hideExecutiveflow () {
        this.hideflow = true
        this.resetapp()
      },
      showExecutiveflow () {
        this.hideflow = false
        this.resetapp()
      },

      resetapp:function(){
        this.outcome={}
        this.stepSelected='0'
      },
      calculate: function(){
            var self =this
            var inputData = JSON.parse(JSON.stringify(this.patientModel))
            if(this.patientModel!=null){
              var obj ={}
              obj.arkID = this.executiveko.naan+'/'+this.executiveko.name+'/'+this.executiveko.ver
              obj.endpoint = '/'+this.executiveko.endpoint
              obj.data= JSON.stringify(inputData)
              obj.key='App'
              obj.success= function(response) {
                console.log(response)
                // console.log("Ref: "+JSON.stringify(response.result.mortalityrate))
                console.log('LE: '+JSON.stringify(response.result.lifeexpectancy))
                self.outcome = response.result
                if(!self.hideflow){
                  var i = 1;
                  self.stepSelected =i+''
                  var interval = setInterval(function(){

                      i++;
                      self.stepSelected =i+''
                      if(i>6) {

                        clearInterval(interval);
                      }
                  }, 1800);
                }
              }
              obj.error=function(resp){
                console.error(resp)
              }

              this.KOPostaxios(obj)
            }
          },
      selectPatient:function(index){
        console.log(index)
        this.patientIndex=index
        this.reclistready =false
      },
      openselector: function(){
        this.$bus.$emit('openselector',true)
      },
      processArray: function (array, fn) {
        var index = 0;
        return new Promise(function(resolve, reject) {
          function next() {
            if (index < array.length) {
              setTimeout(()=>fn(array[index++]).then(next, reject), 1500);
            } else {
              resolve();
            }
          }
          next();
        })
      },

      displaylabel:function(key){
        if(this.myPatient!=null){
          var inx = this.groupSchema.findIndex(function(e,index){
            return e.groupname==key
          })

          if (inx!=-1){
            return this.groupSchema[inx]['label']
          } else {
            return key
          }
        }
      },
      displaycol:function(key){
        if(this.myPatient!=null){
          var inx = this.groupSchema.findIndex(function(e,index){
            return e.groupname==key
          })
          if (inx!=-1){
            return this.groupSchema[inx]['col']
          } else {
            return 1
          }
        }
      },
      KOPostaxios:function(instr){
        var self = this
        var config = {
          method:'post',
          url:this.activator_url+ instr.arkID + instr.endpoint,
          "headers": {
            "content-type": "application/json",
          },
          "data": instr.data
        }
        self.appendLog(instr.key, "K-GRID Service Request - Sending Patient Data to Knowledge Object: " + instr.arkID);
        return this.$http(config)
          .then(function(response){
            instr.success(response.data)
            self.appendLog(instr.key, "K-GRID Service Response - Response results returned from Knowledge Object: " + instr.arkID);
          })
          .catch(function(error){
            console.error(error)
            self.hasError = true;
            if(error.response.status==404){
              self.error404=true;
            }
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            }
            instr.error(error.response.data);
            // self.appendLog('err', "K-GRID Service Response - Error returned from Knowledge Object: " + instr.arkID);
          })
      },
      appendLog: function (key, s) {
        var ts = this.$moment().format('ddd, MMM Do YYYY, h:mm:ss A Z')
        var text = ts+" "+s
        this.$bus.$emit('newentry', text)
      }
    }
  };
</script>
<style scoped>
.container {
  max-width: 100%;
}
.v-timeline {
  max-width: 86%;
  margin:0 auto;
  padding-top: 24px;
}
.patientpanel{
  background-color: #efefef;
  overflow-y:auto;
}
.featurelabel {
  font-size: 0.85rem;
  padding: 0 0.2rem ;
  bottom: 0;
  position: relative;
}
.featurevalue {
  font-size: 1.55rem;
  padding: 0 0.2rem 0 0.4rem;;
}
.v-card__title {
  padding: 6px 16px;
}
.v-list {
  padding: 4px 0;
}
.startbtn {
  position: absolute;
  bottom: 380px;
  width: 100%;
}
.ko {
  border:1px solid #666666;
}
.activestage {
  background-color: #0075bc;
  color: #fff;
}
.rotdown {
  transform: rotate(90deg)
}
.rotup {
  transform: rotate(-90deg)
}
.inlinediv {
  display: inline;
}
</style>
